import { useEffect, useState } from "react";
import css from "./FileDropzoneWithPreview.module.scss";

type FileDropzoneWithPreviewProps = {
    files: File[];
    onAddFiles: (files: FileList | File[]) => void;
    onRemoveFile: (index: number) => void;
    disabled?: boolean;
    /**
     * Количество превью в одной строке.
     * Если не указано — используется адаптивная сетка из CSS.
     */
    previewsPerRow?: number;
};

export default function FileDropzoneWithPreview({
    files,
    onAddFiles,
    onRemoveFile,
    disabled,
    previewsPerRow,
}: FileDropzoneWithPreviewProps) {
    const [dragActive, setDragActive] = useState(false);
    const [previews, setPreviews] = useState<string[]>([]);

    useEffect(() => {
        const urls = files.map((f) => (f?.type?.startsWith('image/') ? URL.createObjectURL(f) : ''));
        setPreviews(urls);
        return () => urls.forEach(u => { if (u) URL.revokeObjectURL(u) });
    }, [files]);

    function onDrag(e: any) {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") setDragActive(true);
        if (e.type === "dragleave") setDragActive(false);
    }

    function onDrop(e: any) {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer?.files?.length) onAddFiles(e.dataTransfer.files);
    }

    function formatMb(bytes: number) {
        return (bytes / (1024 * 1024)).toFixed(2);
    }

    return (
        <>
            <div
                className={`${css.dropArea} ${dragActive ? css.dropAreaActive : ''}`}
                onDragEnter={onDrag}
                onDragOver={onDrag}
                onDragLeave={onDrag}
                onDrop={onDrop}
            >
                <input
                    type="file"
                    multiple
                    className={css.fileInput}
                    onChange={(e) => onAddFiles(e.target.files as FileList)}
                    disabled={disabled}
                />
                <span className={css.dropPrompt}>Перетащите файлы сюда или нажмите для выбора</span>
            </div>
            {files.length > 0 && (
                <div
                    className={css.fileGrid}
                    style={previewsPerRow ? { gridTemplateColumns: `repeat(${previewsPerRow}, 1fr)` } : undefined}
                >
                    {files.map((f, i) => (
                        <div key={`${f.name}-${f.size}-${i}`} className={css.fileCard}>
                            {previews[i]
                                ? <img src={previews[i]} alt={f.name} className={css.thumb} />
                                : <div className={css.fileStub}>{f.name.split('.').pop()?.toUpperCase() || 'FILE'}</div>}
                            <div className={css.fileMeta}>
                                <div className={css.fileNameTrunc} title={f.name}>{f.name}</div>
                                <div className={css.fileSize}>{formatMb(f.size)} Мб</div>
                            </div>
                            <button type="button" className={css.removeBtnCard} aria-label="Удалить" onClick={() => onRemoveFile(i)}>×</button>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
}





